import { Icon, InlineStack, SkeletonBodyText, SkeletonDisplayText, SkeletonThumbnail } from '@shopify/polaris';
import { ChevronDownMinor, ChevronRightMinor } from '@shopify/polaris-icons';
import { Table } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Skeleton = () => {
    const { t } = useTranslation();

    const expandedRowRender = () => {
        const columns = [
            { title: t('Variants'), dataIndex: 'variants', key: 'variants', width: '60%' },
            { title: t('Unique ID'), dataIndex: 'id', key: 'id', width: '40%' },
        ];

        const data = [
            {
                key: '1',
                variants: <SkeletonBodyText lines={1} />,
                id: <SkeletonBodyText lines={1} />,
            },
            {
                key: '2',
                variants: <SkeletonBodyText lines={1} />,
                id: <SkeletonBodyText lines={1} />,
            },
            {
                key: '3',
                variants: <SkeletonBodyText lines={1} />,
                id: <SkeletonBodyText lines={1} />,
            },
        ];

        return <Table columns={columns} dataSource={data} pagination={false} bordered />;
    };

    const dataSource = [
        {
            key: '1',
            product: <InlineStack gap="300" blockAlign='center' wrap={false}>
                <div>
                    <SkeletonThumbnail size="small" />
                </div>
                <SkeletonBodyText lines={1} />
            </InlineStack>,
            tag: <div className='Custom__badge--Skeleton'><SkeletonDisplayText size="medium" /></div>,
            id: <SkeletonBodyText lines={1} />,
            variants: <SkeletonBodyText lines={1} />,
        },
        {
            key: '2',
            product: <InlineStack gap="300" blockAlign='center' wrap={false}>
                <div>
                    <SkeletonThumbnail size="small" />
                </div>
                <SkeletonBodyText lines={1} />
            </InlineStack>,
            tag: <div className='Custom__badge--Skeleton'><SkeletonDisplayText size="medium" /></div>,
            id: <SkeletonBodyText lines={1} />,
            variants: <SkeletonBodyText lines={1} />,
        },
        {
            key: '3',
            product: <InlineStack gap="300" blockAlign='center' wrap={false}>
                <div>
                    <SkeletonThumbnail size="small" />
                </div>
                <SkeletonBodyText lines={1} />
            </InlineStack>,
            tag: <div className='Custom__badge--Skeleton'><SkeletonDisplayText size="medium" /></div>,
            id: <SkeletonBodyText lines={1} />,
            variants: <SkeletonBodyText lines={1} />,
        },
        {
            key: '4',
            product: <InlineStack gap="300" blockAlign='center' wrap={false}>
                <div>
                    <SkeletonThumbnail size="small" />
                </div>
                <SkeletonBodyText lines={1} />
            </InlineStack>,
            tag: <div className='Custom__badge--Skeleton'><SkeletonDisplayText size="medium" /></div>,
            id: <SkeletonBodyText lines={1} />,
            variants: <SkeletonBodyText lines={1} />,
        },
        {
            key: '5',
            product: <InlineStack gap="300" blockAlign='center' wrap={false}>
                <div>
                    <SkeletonThumbnail size="small" />
                </div>
                <SkeletonBodyText lines={1} />
            </InlineStack>,
            tag: <div className='Custom__badge--Skeleton'><SkeletonDisplayText size="medium" /></div>,
            id: <SkeletonBodyText lines={1} />,
            variants: <SkeletonBodyText lines={1} />,
        },
        {
            key: '6',
            product: <InlineStack gap="300" blockAlign='center' wrap={false}>
                <div>
                    <SkeletonThumbnail size="small" />
                </div>
                <SkeletonBodyText lines={1} />
            </InlineStack>,
            tag: <div className='Custom__badge--Skeleton'><SkeletonDisplayText size="medium" /></div>,
            id: <SkeletonBodyText lines={1} />,
            variants: <SkeletonBodyText lines={1} />,
        },

    ];

    const columns: any = [
        {
            title: t('Product'),
            dataIndex: 'product',
            key: 'product',
            width: 250,
        },
        {
            title: '',
            dataIndex: 'tag',
            key: 'tag',
            width: 150,
        },
        {
            title: t('Unique ID'),
            dataIndex: 'id',
            key: 'id',
            width: 150,
        },
        {
            title: t('Variants'),
            dataIndex: 'variants',
            key: 'variants',
            width: 150,
            align: 'center',
        },
    ];

    return (
        <Table
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            size='middle'
            expandable={
                {
                    expandedRowRender,
                    expandIcon: ({ expanded, onExpand, record }) => {
                        return expanded ?
                            <span style={{ cursor: 'pointer' }} onClick={(e: any) => onExpand(record, e)}>
                                <div><Icon source={ChevronDownMinor} tone="base" /></div>
                            </span>
                            :
                            <span style={{ cursor: 'pointer' }} onClick={(e: any) => onExpand(record, e)}>
                                <div><Icon source={ChevronRightMinor} tone="base" /></div>
                            </span>
                    }
                }}
            scroll={{ x: 700 }}
        />
    );
}
export default Skeleton;